import { useState } from 'react';
import { useActivityShopUI } from 'hooks/useActivityShopUI';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CartDialog from 'components/activity-display/control-header/CartDialog';
import DefaultThemeWrapper from 'components/themes/DefaultThemeWrapper';

import { formatNumberWithSpacesAndRounding } from 'utils/formatUtils';

function CartButton() {
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.down('md'));

	const [cartIsOpen, setCartIsOpen] = useState(false);

	const { getTotalPrice, selectedCurrencyCode, activitiesInteractionData, getItemsInCartQty } = useActivityShopUI();

	const totalPrice = getTotalPrice(activitiesInteractionData);
	const itemsInCartQty = getItemsInCartQty();
	

	function handleCartClick() {
		setCartIsOpen(true);
	}

	return(
		<>
			<Button
				className="tt-cart-button"
				onClick={handleCartClick}
			>
				{ (totalPrice > 0 && !isXs) ? <span style={{ paddingRight: '20px' }}>{formatNumberWithSpacesAndRounding(totalPrice)} {selectedCurrencyCode}</span> : null }
				<ShoppingCartIcon style={{ marginRight: '20px' }} />
				{itemsInCartQty}
			</Button>
			<DefaultThemeWrapper>
				<CartDialog cartIsOpen={cartIsOpen} setCartIsOpen={setCartIsOpen} />
			</DefaultThemeWrapper>
		</>
	);
}

export default CartButton;